document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth >= 990) {
    const detailsElements = document.querySelectorAll('.header__inline-menu details');

    detailsElements.forEach((details) => {
      const summary = details.querySelector('summary');
      const link = summary.querySelector('[data-parent-link]');
      let closeTimeout;

      // Open submenu instantly
      details.addEventListener('mouseenter', () => {
        // Close all other menus immediately
        detailsElements.forEach((otherDetails) => {
          if (otherDetails !== details) {
            otherDetails.removeAttribute('open');
          }
        });

        clearTimeout(closeTimeout); // Cancel any pending close
        details.setAttribute('open', true);
      });

      // Delay close when mouse leaves
      details.addEventListener('mouseleave', () => {
        closeTimeout = setTimeout(() => {
          details.removeAttribute('open');
        }, 150); // small delay to allow natural cursor movement
      });

      // Click redirect
      if (link) {
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          window.location.href = link.href;
        });
      }
    });
  }
});
